var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-skeleton-loader",
    {
      staticClass: "dashboard-component d-flex",
      attrs: {
        transition: "scale-transition",
        type: "image",
        "min-height": "335",
        height: "335",
        "max-height": "500",
        loading: _vm.isLoading
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "pull-up" },
        [
          _c(
            "v-card-title",
            { staticClass: "overline pb-1 d-flex justify-start" },
            [_c("h3", [_vm._v("Tickets gestionados por estado")])]
          ),
          _c(
            "v-card-text",
            {
              staticClass: "d-flex justify-center",
              attrs: { collapse: "", show: "" }
            },
            [
              _c("apexchart", {
                staticClass: "dashboard-chart",
                attrs: {
                  type: _vm.chartType,
                  options: _vm.chartOptions,
                  series: _vm.chartData.series
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }